module.exports = __webpack_public_path__ + "img/Banner Mobile_TH.0913fa41.png";